export default __webpack_public_path__ + "static/media/react.20adfb35.png";